module.exports = __webpack_public_path__ + "static/flags/TT-6bf28727786276ae02d825f5e242052d.gif";